var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.177,
    height: 14.022,
    viewBox: "0 0 14.177 14.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6815",
    "data-name": "Group 6815",
    transform: "translate(-202.552 -22.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6814",
    "data-name": "Group 6814",
    transform: "translate(202.552 26.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8910",
    "data-name": "Path 8910",
    d: "M195.414,814.978a.736.736,0,0,0-.565.258l-2.41,2.41-2.367-2.367c-.044-.044-.087-.087-.133-.127a.664.664,0,0,0-.757-.107.755.755,0,0,0-.463.678.736.736,0,0,0,.258.565l2.41,2.41,1.052,1.052,3.418-3.418c.044-.044.087-.087.127-.133a.666.666,0,0,0,.108-.758.755.755,0,0,0-.678-.463",
    transform: "translate(-185.353 -814.979)",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8911",
    "data-name": "Path 8911",
    d: "M196.406,822.727h-8.46a2.862,2.862,0,0,1-2.858-2.858v-2.54a.675.675,0,0,1,1.349,0v2.54a1.512,1.512,0,0,0,1.51,1.505h8.46a1.512,1.512,0,0,0,1.51-1.51v-2.54a.675.675,0,0,1,1.349,0v2.54a2.862,2.862,0,0,1-2.858,2.858",
    transform: "translate(-185.087 -811.905)",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8912",
    "data-name": "Path 8912",
    d: "M192.682,818.588a.675.675,0,0,1-.675-.675v-5.686a.675.675,0,0,1,1.349-.05.455.455,0,0,1,0,.05v5.686a.675.675,0,0,1-.675.675",
    transform: "translate(-185.593 -814.727)",
    fill: "#003189"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlue);
export default __webpack_public_path__ + "static/media/download-blue.3493864e76edff2853b5a67d5c0ee868.svg";
export { ForwardRef as ReactComponent };